(function () {
    'use strict';

    angular.module('Services').factory('ThresholdTableService', ThresholdTableService);

    ThresholdTableService.$inject = [
        'Units', 
        'Carrier', 
        'TableLiteFactory', 
        'toastr', 
        '$timeout', 
        'patternFactory',
        '$q', 
        'ConfirmationModalFactory'
    ];

    function ThresholdTableService(
        Units, 
        Carrier, 
        TableLiteFactory, 
        toastr, 
        $timeout, 
        patternFactory, 
        $q, 
        ConfirmationModalFactory
    ) {
        return function (serviceProfile, options) {
            let Unitweight = options.weightUnit;
            let Unitmeasure =options.measureUnit;
            let viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.delete.MESSAGE',
                code: 'messages.warning.delete.CODE',
            });
            const weightUnit = Units.weightUnit.find(unit=>unit.value === options.weightUnit).short.toUpperCase();
            const measureUnit = Units.measureUnit.find(unit=>unit.short === options.measureUnit).short.toUpperCase();

            // TODO WE DONT USE THIS ONE, REMOVE IN THE FUTURE
            function getThresholdData(id, successCallback, error, filter) {
                let data = {
                    content: [],
                    number: 0,
                    numberOfElements: 10,
                    size: 10,
                    sort: [{
                        direction: "DESC",
                        property: "id",
                        ignoreCase: false,
                        nullHandling: "NATIVE",
                        descending: true
                    }],
                    totalElements: 10,
                    totalPages: 1
                };
                $timeout(() => {
                    for (let x = 0; x <= 4; x++) {
                        const weight = [randomize(80), randomize(100)];
                        const deadWeight = [randomize(80), randomize(100)];
                        data.content.push({
                            priority: x,
                            conversionFactor: randomize(150),
                            minCubicWeight: weight[0] < weight[1] ? weight[0] : weight[1],
                            maxCubicWeight: weight[0] > weight[1] ? weight[0] : weight[1],
                            minDeadWeight: deadWeight[0] < deadWeight[1] ? deadWeight[0] : deadWeight[1],
                            maxDeadWeight: deadWeight[0] > deadWeight[1] ? deadWeight[0] : deadWeight[1]
                        });
                        successCallback(data);
                    }
                });
            }

            function randomize(length) {
                return Math.floor((Math.random() * length) + 1);
            }

            const tableHeaders = {
                weight: [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Conversion Factor',
                        viewName: 'conversionFactorEdit',
                        fieldName: 'conversionFactor',
                        unit: `${weightUnit}/${measureUnit}<sup>3</sup>`,
                        viewTooltip: function(row) {
                            let value = +row.conversionFactor;
                            const multiplier = 36.1273;
                            const isMetric = row.measureUnit === 'cm';
                            if (isMetric) {
                                value *= multiplier;
                            } else {
                                value /= multiplier;
                            }
                            return value + ' ' + (isMetric ? 'LBS/IN^3' : 'KG/M^3');
                        }
                    },
                    {
                        label: 'Min Cubic Weight',
                        viewName: 'minCubicWeightEdit',
                        fieldName: 'minCubicWeight',
                        hasError: function (row, name) {
                            if (!tableStructure.form[name] && row.minCubicWeightEdit.valTemp && row.maxCubicWeightEdit.valTemp) {
                                this.tooltip = null;
                                return false;
                            }

                            if ((Number(row.minCubicWeightEdit.valTemp) > Number(row.maxCubicWeightEdit.valTemp))
                                && (tableStructure.form.$submitted || tableStructure.form[name].$touched)) {
                                this.tooltip = 'Min cubic weight must be lower than max cubic weight';
                                return true;
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: weightUnit
                    }, {
                        label: 'Max Cubic Weight',
                        viewName: 'maxCubicWeightEdit',
                        fieldName: 'maxCubicWeight',
                        hasError: function (row, name) {
                            if (!tableStructure.form[name] && row.minCubicWeightEdit.valTemp && row.maxCubicWeightEdit.valTemp) {
                                this.tooltip = null;
                                return false;
                            }

                            if ((Number(row.minCubicWeightEdit.valTemp) > Number(row.maxCubicWeightEdit.valTemp))
                                && (tableStructure.form.$submitted || tableStructure.form[name].$touched)) {
                                this.tooltip = 'Max cubic weight must be higher than min cubic weight';
                                return true;
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: weightUnit
                    }, {
                        label: 'Min Dead Weight',
                        viewName: 'minDeadWeightEdit',
                        fieldName: 'minDeadWeight',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minDeadWeightEdit.valTemp && row.maxDeadWeightEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minDeadWeightEdit.valTemp) > Number(row.maxDeadWeightEdit.valTemp)){
                                        this.tooltip = 'Min dead weight must be lower than max dead weight';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: weightUnit
                    }, {
                        label: 'Max Dead Weight',
                        viewName: 'maxDeadWeightEdit',
                        fieldName: 'maxDeadWeight',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minDeadWeightEdit.valTemp && row.maxDeadWeightEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minDeadWeightEdit.valTemp) > Number(row.maxDeadWeightEdit.valTemp)){
                                        this.tooltip = 'Min dead weight must be lower than max dead weight';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: weightUnit
                    }],
                dimension:  [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Min Length',
                        viewName: 'minLengthEdit',
                        fieldName: 'minLength',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minLengthEdit.valTemp && row.maxLengthEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minLengthEdit.valTemp) > Number(row.maxLengthEdit.valTemp)){
                                        this.tooltip = 'Min length must be lower than max max length';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Max Length',
                        viewName: 'maxLengthEdit',
                        fieldName: 'maxLength',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minLengthEdit.valTemp && row.maxLengthEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minLengthEdit.valTemp) > Number(row.maxLengthEdit.valTemp)){
                                        this.tooltip = 'Min length must be lower than max max length';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Min Width',
                        viewName: 'minWidthEdit',
                        fieldName: 'minWidth',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minWidthEdit.valTemp && row.maxWidthEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minWidthEdit.valTemp) > Number(row.maxWidthEdit.valTemp)){
                                        this.tooltip = 'Min length must be lower than max max length';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Max Width',
                        viewName: 'maxWidthEdit',
                        fieldName: 'maxWidth',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minWidthEdit.valTemp && row.maxWidthEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minWidthEdit.valTemp) > Number(row.maxWidthEdit.valTemp)){
                                        this.tooltip = 'Min length must be lower than max max length';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Min Height',
                        viewName: 'minHeightEdit',
                        fieldName: 'minHeight',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minHeightEdit.valTemp && row.maxHeightEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minHeightEdit.valTemp) > Number(row.maxHeightEdit.valTemp)){
                                        this.tooltip = 'Min height must be lower than max height';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Max Height',
                        viewName: 'maxHeightEdit',
                        fieldName: 'maxHeight',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minHeightEdit.valTemp && row.maxHeightEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minHeightEdit.valTemp) > Number(row.maxHeightEdit.valTemp)){
                                        this.tooltip = 'Min height must be lower than max height';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }],
                distance: [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Min Travel Distance',
                        viewName: 'minTravelDistanceEdit',
                        fieldName: 'minTravelDistance',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minTravelDistanceEdit.valTemp && row.maxTravelDistanceEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minTravelDistanceEdit.valTemp) > Number(row.maxTravelDistanceEdit.valTemp)){
                                        this.tooltip = 'Min height must be lower than max height';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: 'KM'
                    }, {
                        label: 'Max Travel Distance',
                        viewName: 'maxTravelDistanceEdit',
                        fieldName: 'maxTravelDistance',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minTravelDistanceEdit.valTemp && row.maxTravelDistanceEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minTravelDistanceEdit.valTemp) > Number(row.maxTravelDistanceEdit.valTemp)){
                                        this.tooltip = 'Min height must be lower than max height';
                                        return true
                                    }
                                }
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: 'KM'
                    }],
                item: [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Min Number of Items/Packages',
                        viewName: 'minNoShipmentsEdit',
                        fieldName: 'minItem',
                        inputType: 'MIN_NUMBER_OF_ITEMS_PACKAGES',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minNoShipmentsEdit.valTemp && row.maxNoShipmentsEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minNoShipmentsEdit.valTemp) > Number(row.maxNoShipmentsEdit.valTemp)){
                                        return true
                                    }
                                }
                            }
                            return false;
                        }
                    }, {
                        label: 'Max Number of Items/Packages',
                        viewName: 'maxNoShipmentsEdit',
                        fieldName: 'maxItem',
                        inputType: 'MAX_NUMBER_OF_ITEMS_PACKAGES',
                        hasError: function (row, name) {
                            if(!tableStructure.form[name]) return false;

                            if (row.minNoShipmentsEdit.valTemp && row.maxNoShipmentsEdit.valTemp) {
                                if(tableStructure.form[name].$touched || tableStructure.form.$submitted){
                                    if(Number(row.minNoShipmentsEdit.valTemp) > Number(row.maxNoShipmentsEdit.valTemp)){
                                        return true
                                    }
                                }
                            }
                            return false;
                        }
                    }],
                'manual-handling': [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Weight',
                        viewName: 'weightEdit',
                        fieldName: 'weight',
                        unit: weightUnit
                    }, {
                        label: 'Length',
                        viewName: 'lengthEdit',
                        fieldName: 'length',
                        unit: measureUnit
                    }, {
                        label: 'Width',
                        viewName: 'widthEdit',
                        fieldName: 'width',
                        unit: measureUnit
                    }, {
                        label: 'Height',
                        viewName: 'heightEdit',
                        fieldName: 'height',
                        unit: measureUnit
                    }, {
                        label: 'Volume',
                        viewName: 'volumeEdit',
                        fieldName: 'volume'
                    }, {
                        label: 'Fee',
                        viewName: 'feeEdit',
                        fieldName: 'fee',
                        unit: options.currency
                    }
                ],
                oversize: [
                    {
                        label: 'Priority',
                        viewName: 'priorityEdit',
                        fieldName: 'priority'
                    }, {
                        label: 'Weight',
                        viewName: 'weightEdit',
                        fieldName: 'weight',
                        unit: weightUnit
                    }, {
                        label: 'Min Length',
                        viewName: 'minLengthEdit',
                        fieldName: 'minLength',
                        hasError: function (row, name) {
                            const minLength = angular.isDefined(row.minLengthEdit.valTemp) ? Number(row.minLengthEdit.valTemp) : 0;
                            const maxLength = angular .isDefined(row.maxLengthEdit.valTemp) ? Number(row.maxLengthEdit.valTemp): 0;

                            if (!tableStructure.form[name] && row.minLengthEdit.valTemp && row.maxLengthEdit.valTemp) {
                                this.tooltip = null;
                                return false;
                            }
                            if ((minLength > maxLength)
                                && (tableStructure.form.$submitted || tableStructure.form[name].$touched)) {
                                this.tooltip = 'Min length must be lower than max max length';
                                return true;
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Max Length',
                        viewName: 'maxLengthEdit',
                        fieldName: 'maxLength',
                        hasError: function (row, name) {
                            const minLength = angular.isDefined(row.minLengthEdit.valTemp) ? Number(row.minLengthEdit.valTemp) : 0;
                            const maxLength = angular .isDefined(row.maxLengthEdit.valTemp) ? Number(row.maxLengthEdit.valTemp): 0;

                            if (!tableStructure.form[name] && row.minLengthEdit.valTemp && row.maxLengthEdit.valTemp) {
                                this.tooltip = null;
                                return false;
                            }
                            if ((minLength > maxLength)
                                && (tableStructure.form.$submitted || tableStructure.form[name].$touched)) {
                                this.tooltip = 'Max length must be higher than min length';
                                return true;
                            }
                            this.tooltip = null;
                            return false;
                        },
                        unit: measureUnit
                    }, {
                        label: 'Volume',
                        viewName: 'volume',
                        fieldName: 'volume'
                    }, {
                        label: 'Fee',
                        viewName: 'feeEdit',
                        fieldName: 'fee',
                        unit: options.currency
                    }
                ]
            };
            const addLabel = {
                weight: 'ADD WEIGHT THRESHOLD',
                dimension: 'ADD DIMENSION THRESHOLD',
                distance: 'ADD DISTANCE THRESHOLD',
                item: 'ADD ITEM THRESHOLD',
                'manual-handling': 'ADD MANUAL HANDLING THRESHOLD',
                oversize: 'OVERSIZE THRESHOLD'
            };
            const cleanData = {
                weight: cleanWeightPayload,
                dimension: cleanDimensionPayload,
                distance: cleanDistancePayload,
                item: cleanItemPayload,
                'manual-handling': cleanManualPayload,
                oversize: cleanOversizePayload
            };
            const headers = tableHeaders[options.path];
            const tableStructure = {
                form: serviceProfile.thresholdForm,
                config: {
                    tableMinHeight: '0px'
                },
                optionAddOns: {
                    buttons: [{
                        class: options.readOnly ? 'btn-disabled' : 'btn-primary',
                        label: addLabel[options.path],
                        onClick: function () {
                            if (options.readOnly) { return; }
                            const item = angular.extend(buildValues({}), {isNew: true});
                            item.action.buttons[0].action(item);
                            tableStructure.data.push(item);
                        },
                        hide: function () {
                            return tableStructure.data.length >= 3;
                        }
                    }]
                },
                headers: [...headers, {
                    label: 'Action',
                    viewName: 'action'
                }],
                data: [],
                patternDecimal: patternFactory.decimal,
                roundDown: function (model, viewName) {
                    const limitTo4DecimalPlaces = [
                        'minCubicWeightEdit',
                        'maxCubicWeightEdit',
                        'minDeadWeightEdit',
                        'maxDeadWeightEdit'
                    ];

                    if(limitTo4DecimalPlaces.indexOf(viewName) !== -1) {
                        return Number(model);
                    }

                    return  viewName !== "conversionFactorEdit" ? Math.floor(+model) : model;
                }
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: Carrier.getAllServiceThresholds,
                //serviceCallback: getThresholdData,
                callbackFormat: ['options', 'success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                },
                options: {
                    path: options.path,
                    serviceProfileId: serviceProfile.id
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildValues(data) {
                let row = data;
                headers.map(header => {
                    let convertVal = row[header.fieldName];
                    if(header.unit==='LBS'){
                         convertVal = row[header.fieldName] ;
                    }

                    if(header.unit==='IN'){
                        convertVal = row[header.fieldName] ;
                    }

                    if(header.unit==='LBS/IN<sup>3</sup>'){
                        convertVal = row[header.fieldName] ;
                    }

                    const valTemp = row[header.fieldName];
                    const valFormatted = header.unit ? `${convertVal} ${header.unit}` : row[header.fieldName];

                    row[header.viewName] = {
                        url: '/templates/pages/carriers/thresholdCells/editable.html',
                        value: convertVal ,
                        inputType: header.inputType,
                        valueFormatted: valTemp || parseFloat(valTemp) === 0 ? valFormatted : null,
                        error: {
                            hasError: header.hasError
                        }
                    }
                   
                });

                const action = {
                    type: 'button',
                    buttons: [{
                        class: `btn btn-primary btn-circle glyphicon glyphicon-pencil ${options.readOnly ? 'btn-disabled' : ''}`,
                        action: row => {
                            if (!row.editMode) {
                                tableStructure.form.$setPristine();
                                headers.map(header => {
                                    row[header.viewName].valTemp = angular.copy(row[header.viewName].value);
                                });
                                row.editMode = !row.editMode;
                                changeButtons(row);
                            } else {
                                tableStructure.form.$setSubmitted();
                                if (tableStructure.form.$invalid) {
                                    return false;
                                }
                                updateCreateThreshold(row).then(()=>sendRequest());

                                /*headers.map(header=>{
                                    const valTemp = angular.copy(row[header.viewName].valTemp);
                                    const valFormatted = header.unit ? `${valTemp} ${header.unit}` : valTemp;
                                    row[header.viewName].value = valTemp;
                                    row[header.viewName].valueFormatted = valTemp || parseFloat(valTemp) === 0 ? valFormatted : null;
                                });
                                row.editMode = !row.editMode;
                                changeButtons(row);*/
                            }
                        }
                    }, {
                        class: `btn btn-danger btn-circle glyphicon glyphicon-trash ${options.readOnly ? 'btn-disabled' : ''}`,
                        action: row => {
                            if (row.isNew) {
                                tableStructure.data.splice(tableStructure.data.indexOf(row), 1);
                                return false;
                            }
                            if (row.editMode) {
                                row.editMode = false;
                                changeButtons(row);
                                return false;
                            }
                            viewConfirmation.getInstance().result.then(res=>{
                                if(res)
                                    deleteThreshold(row.id).then(()=>sendRequest());
                            });
                        }
                    }]
                };
                row.action = action;

                function changeButtons(row) {
                    if (row.editMode) {
                        row.action.buttons[0].class = 'btn btn-success btn-circle glyphicon glyphicon-ok';
                        row.action.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-remove';
                        return false;
                    }
                    row.action.buttons[0].class = 'btn btn-primary btn-circle glyphicon glyphicon-pencil';
                    row.action.buttons[1].class = 'btn btn-danger btn-circle glyphicon glyphicon-trash';
                }

                return row;
            }

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    tableStructure.data.push(angular.extend(row, buildValues(row)));
                })
            }
            function updateCreateThreshold(data) {
                const defer = $q.defer();
                if(!data.id){
                    Carrier.createServiceThreshold({
                        serviceProfileId: serviceProfile.id,
                        path: options.path
                    },data=>{
                        toastr.success('New threshold created!');
                        defer.resolve();
                    },err=> {
                        toastr.error('Unable to create threshold', err.message);
                        defer.reject();
                    },cleanData[options.path](data));
                }else{
                    Carrier.updateServiceThreshold({
                        serviceProfileId: serviceProfile.id,
                        path: options.path,
                        thresholdId: data.id
                    },data=>{
                        
                        toastr.success('Threshold updated!');
                        defer.resolve();
                    },err=> {
                        toastr.error('Unable to update threshold', err.message);
                        defer.reject();
                    },cleanData[options.path](data));
                }
                return defer.promise;
            }
            function deleteThreshold(id) {
                const defer = $q.defer();
                Carrier.deleteServiceThreshold({
                    serviceProfileId: serviceProfile.id,
                    thresholdId: id,
                    path: options.path
                },data=>{
                    toastr.success('Threshold deleted');
                    defer.resolve();
                },err=>{
                    toastr.error('Unable to delete threshold', err.error);
                    defer.reject();
                });
                return defer.promise;
            }

            function cleanDimensionPayload(data) {
                console.log(data)
                return {
                    "priority": data.priorityEdit.valTemp,
                    "minLength": data.minLengthEdit.valTemp,
                    "maxLength": data.maxLengthEdit.valTemp,
                    "minWidth": data.minWidthEdit.valTemp,
                    "maxWidth": data.maxWidthEdit.valTemp,
                    "minHeight": data.minHeightEdit.valTemp,
                    "maxHeight": data.maxHeightEdit.valTemp,
                    "measureUnit": Unitmeasure,
                    "weightUnit": Unitweight
                }
            }
            function cleanWeightPayload(data) {
                return {
                    "priority": data.priorityEdit.valTemp,
                    "conversionFactor": data.conversionFactorEdit.valTemp,
                    "minCubicWeight": data.minCubicWeightEdit.valTemp,
                    "maxCubicWeight": data.maxCubicWeightEdit.valTemp,
                    "minDeadWeight": data.minDeadWeightEdit.valTemp,
                    "maxDeadWeight": data.maxDeadWeightEdit.valTemp,
                    "measureUnit": Unitmeasure,
                    "weightUnit": Unitweight
                }
            }
            function cleanDistancePayload(data) {
                return {
                    "priority": data.priorityEdit.valTemp,
                    "minTravelDistance": data.minTravelDistanceEdit.valTemp,
                    "maxTravelDistance": data.maxTravelDistanceEdit.valTemp,
                    "distanceUnit": "kilometers"
                }
            }
            function cleanItemPayload(data) {
                return {
                    "priority": data.priorityEdit.valTemp,
                    "minItem": data.minNoShipmentsEdit.valTemp,
                    "maxItem": data.maxNoShipmentsEdit.valTemp
                }
            }

            function cleanManualPayload(data) {
                return {
                    'priority': data.priorityEdit.valTemp,
                    'weight': data.weightEdit.valTemp,
                    'length': data.lengthEdit.valTemp,
                    'width': data.widthEdit.valTemp,
                    'height': data.heightEdit.valTemp,
                    'volume': data.volumeEdit.valTemp,
                    'fee': data.feeEdit.valTemp,
                    'currency': options.currency,
                    'measureUnit': Unitmeasure,
                    'weightUnit': Unitweight
                };
            }

            function cleanOversizePayload(data) {
                return {
                    'priority': Number(data.priorityEdit.valTemp),
                    'weight': Number(data.weightEdit.valTemp),
                    'minLength': Number(data.minLengthEdit.valTemp),
                    'maxLength': Number(data.maxLengthEdit.valTemp),
                    'volume': Number(data.volume.valTemp),
                    'fee': Number(data.feeEdit.valTemp),
                    'currency': options.currency,
                    'measureUnit': Unitmeasure,
                    'weightUnit': Unitweight
                }
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ThresholdTableService.js